import { colorsPalettes } from "@similarweb/styles";
import { Combobox } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

type RoleChangeTypeOptionContentProps = {
    label: string;
    description: string;
    isSelected: boolean;
};

export const RoleChangeTypeOptionContent = ({ label, description, isSelected }: RoleChangeTypeOptionContentProps) => {
    return (
        <Flex
            alignItems="flex-start"
            justifyContent="space-between"
            gap="8px"
            width="100%"
        >
            <Stack gap="2px">
                <Combobox.OptionLabel>
                    <Text
                        fontVariant="body2"
                        color={colorsPalettes.carbon["500"]}
                    >
                        {label}
                    </Text>
                </Combobox.OptionLabel>
                <Text
                    fontVariant="listItem3"
                    color={colorsPalettes.carbon["300"]}
                >
                    {description}
                </Text>
            </Stack>
            <Combobox.OptionCheckbox isChecked={isSelected} />
        </Flex>
    );
};
